import { Observable } from 'rxjs';
import { shareReplay } from 'rxjs/operators';

export default function memoizeObservable<T extends any[], R>(
  fn: (...args: T) => Observable<R>
): (...args: T) => Observable<R> {
  const cache = new Map<string, Observable<R>>();

  return function(...args: T): Observable<R> {
    const key = args.join('-');

    if (cache.has(key)) {
      return cache.get(key)!;
    }

    const observable = fn(...args).pipe(
      shareReplay({ bufferSize: 1, refCount: true })
    );

    cache.set(key, observable);
    return observable;
  };
}
